import React, { useState } from 'react';
import { ContentLayout } from 'src/components/ContentLayout';
import { OperatorFlowTable } from 'src/components/OperatorFlowTable';
import { DateRangePicker } from 'src/components/DateRangePicker';
import { useParams, useSearchParams } from 'react-router-dom';

import {
  convertDateToEpochTimeInSeconds,
  getDateRangeFromToday,
} from 'src/utils/timeUtils';
import { useQuery } from '@tanstack/react-query';
import { apiGetRequest } from 'src/utils/mlPigeonAPIRequest';
import { urlList } from 'src/context/url';

export function OperatorFlowsPage() {
  const { modelArtifactId } = useParams<Record<string, string>>();
  const [searchParams, setSearchParams] = useSearchParams();
  const params = new URLSearchParams(searchParams);
  const startDate = params.get('startDate');
  const endDate = params.get('endDate');

  const [dateRange, setDateRange] = useState<DateRange>(
    startDate && endDate
      ? { startDate: new Date(startDate), endDate: new Date(endDate) }
      : getDateRangeFromToday(30),
  );

  const { data, isLoading, error } = useQuery<OperatorFlowJob[], Error>({
    queryKey: ['operatorFlowJobs', modelArtifactId, dateRange],
    queryFn: () => {
      dateRange.startDate.setHours(0, 0, 0, 0);
      dateRange.endDate.setHours(23, 59, 59, 999);
      return apiGetRequest({
        endpoint: urlList.operatorFlowJobs,
        params: {
          modelArtifactId: modelArtifactId || '',
          startTime: convertDateToEpochTimeInSeconds(
            dateRange.startDate,
          ).toString(),
          endTime: convertDateToEpochTimeInSeconds(
            dateRange.endDate,
          ).toString(),
        },
      });
    },
  });

  return (
    <ContentLayout
      heading={
        <>
          <h1>Operator Flows</h1>
        </>
      }
    >
      <DateRangePicker
        initDateRange={dateRange}
        changeDateRange={setDateRange}
        setSearchParams={setSearchParams}
      />
      <OperatorFlowTable data={data} loading={isLoading} error={error} />
    </ContentLayout>
  );
}
